<template>
  <div class="page password-reminder">
    <p class="page__logo">
      <img
        src="@/assets/images/logo@2x.png">
    </p>
    <div class="page__form general-form pt-4 p-md-6">
      <div class="general-form__text">
        <p>パスワードをリセットします。<br>再設定先のURLは登録したメールアドレスに届きます。登録に使用したメールアドレスを入力の上送信してください。</p>
      </div>
      <form>
        <validation-observer v-slot="{ invalid }">
          <div class="general-form__group form-group pb-4 mt-3 mt-md-4">
            <label
              for="email"
              class="col-form-label">登録メールアドレス</label>
            <validation-provider
              v-slot="v" 
              name="メールアドレス"
              rules="email|required">
              <b-form-input
                v-model="email"
                type="email"
                placeholder="sample@t-today.jp"
                data-testid="email-input" />
              <p
                class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
            <p class="mt-2 pb-3">
              <b-form-invalid-feedback
                v-for="message in nonFieldErrors"
                :key="message"
                :state="false">
                {{ message }}
              </b-form-invalid-feedback>
            </p>
          </div>
          <div class="general-form__btn mt-5">
            <button
              type="button"
              class="btn btn-block btn-primary"
              :disabled="invalid || succeeded"
              @click="onClickReset">
              パスワードをリセット
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
import { load } from 'recaptcha-v3'
export default {
  beforeRouteLeave(to, from, next) {
    if (this.recaptcha) {
      this.recaptcha.hideBadge()
    }
    next()
  },
  data() {
    return {
      email: '',
      recaptcha: null,
      recaptchaToken: null,
      nonFieldErrors: [],
      succeeded: false
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.loadRecaptcha().catch(() => {
      this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
      this.$router.push('/auth/login')
    })
    this.$store.commit('finishLoading')
  },
  methods: {
    async loadRecaptcha() {
      this.recaptcha = await load(process.env.VUE_APP_RECAPTCHA_SITE_KEY)
      this.recaptcha.showBadge()
    },
    async onClickReset() {
      this.$store.commit('startLoading')

      this.recaptchaToken = await this.recaptcha.execute('password_reset')
        .catch(() => {
          this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
          this.$router.push('/auth/login')
        })
      if (!this.recaptchaToken) {
        this.$store.commit('finishLoading')
        return
      }

      const postBody = {
        email: this.email, 
        recaptcha: this.recaptchaToken
      }
      this.$axios.post('/auth/password/reset/', postBody)
        .then(() => {
          this.succeeded = true
          this.$store.commit('notify/set', {
            message: 'パスワードのリセットが完了しました。ご登録のメールアドレスにURLを添付したメールを送りましたので、ご確認ください。'
          })
        }).catch(() => {
          this.$store.commit('notify/set', {type: 'danger', message: '不明なエラーが発生しました。しばらく時間をあけてアクセスし直してください。なお、連続して発生する場合はログインページ下のアプリ更新を押してください。'})
          this.$router.push('/auth/login')
        }).finally(()=> {
          this.$store.commit('finishLoading')
        })
    }
  }
}
</script>

<style lang="sass" scoped></style>
